import Vue from 'vue'
import HomeRouter from './router/home-router'

export default [
  ...HomeRouter,
]

